import { Chain } from '@ankr.com/chains-list';
import { useMemo } from 'react';

import { ANIMATION_DURATION } from 'domains/projects/screens/ProjectPage/components/ProjectChainsAccordion/components/AccordionItem/hooks/useAccordionItem';
import { JWT } from 'domains/jwtToken/types';
import { filterChainByPaths } from 'modules/chains/utils/filterChainByPaths';
import { hasAllBlockchainsInWhitelist } from 'modules/projects/utils/hasAllBlockchainsInWhitelist';
import { useSelectTokenIndex } from 'domains/jwtToken/hooks/useSelectTokenIndex';
import { waitFor } from 'modules/common/utils/waitFor';

export interface IUseProjectActionsProps {
  chain: Chain;
  jwt: JWT;
  projectWhitelistBlockchains: string[];
}

export const useProjectActions = ({
  chain,
  jwt,
  projectWhitelistBlockchains,
}: IUseProjectActionsProps) => {
  const { index: currentProjectIndex, userEndpointToken } = jwt;

  const projectChain = useMemo(() => {
    if (hasAllBlockchainsInWhitelist(projectWhitelistBlockchains)) {
      return chain;
    }

    return filterChainByPaths({ chain, paths: projectWhitelistBlockchains });
  }, [chain, projectWhitelistBlockchains]);

  const { handleSelectTokenIndex } = useSelectTokenIndex();

  const onCodeExampleModalOpen = async () => {
    handleSelectTokenIndex(currentProjectIndex);

    await waitFor(ANIMATION_DURATION);
  };

  return {
    onCodeExampleModalOpen,
    projectChain,
    userEndpointToken,
  };
};
